module.exports = __webpack_public_path__ + "img/c.0ed12ec2.png";